// extracted by mini-css-extract-plugin
export var container = "city-selection-view-module--container--2bdCE";
export var prefectureText = "city-selection-view-module--prefectureText--31YVh";
export var cityRow = "city-selection-view-module--cityRow--2kJ0_";
export var cityLinkText = "city-selection-view-module--cityLinkText--XbyuV";